import Vue from 'vue'
import VueRouter from 'vue-router'
import { R, LEGACY_PATH_MAP } from '@/config/siteRoutes'
import { applyRouteSeo } from '@/utils/seo'
import lanhu_4chanpinxiangqingb from '../views/lanhu_4chanpinxiangqingb/index.vue'
import lanhu_3chanpinxiangqinga from '../views/lanhu_3chanpinxiangqinga/index.vue'
import lanhu_9chanpinjuzhen from '../views/lanhu_9chanpinjuzhen/index.vue'
import lanhu_8chanpinxiangqinga from '../views/lanhu_8chanpinxiangqinga/index.vue'
import lanhu_project_site from '../views/lanhu_project_site/index.vue'
import lanhu_10hangyejiejuefangan from '../views/lanhu_10hangyejiejuefangan/index.vue'
import lanhu_10hangyejiejuefangan_1 from '../views/lanhu_10hangyejiejuefangan_1/index.vue'
import lanhu_2chanpinliebiao from '../views/lanhu_2chanpinliebiao/index.vue'
import lanhu_7chanpinliebiao from '../views/lanhu_7chanpinliebiao/index.vue'
import lanhu_1shouye from '../views/lanhu_1shouye/index.vue'
import lanhu_about from '../views/lanhu_about/index.vue'
import lanhu_wurenjijiejuefangan from '../views/lanhu_wurenjijiejuefangan/index.vue'
import lanhu_jiejuefanganzhongwen from '../views/lanhu_jiejuefanganzhongwen/index.vue'
import lanhu_jiejuefanganyingwen from '../views/lanhu_jiejuefanganyingwen/index.vue'

Vue.use(VueRouter)

function legacyRedirect(to) {
  const target = LEGACY_PATH_MAP[to.path]
  if (!target) return null
  return { path: target, query: to.query, hash: to.hash, replace: true }
}

const routes = [
  {
    path: R.HOME,
    name: 'home',
    component: lanhu_1shouye,
    meta: { seoId: 'home' }
  },
  {
    path: R.ABOUT,
    name: 'about',
    component: lanhu_about,
    meta: { seoId: 'about' }
  },
  {
    path: R.PROJECTS,
    name: 'projects',
    component: lanhu_project_site,
    meta: { seoId: 'projects' }
  },
  {
    path: R.PRODUCTS,
    name: 'products',
    component: lanhu_7chanpinliebiao,
    meta: { seoId: 'products' }
  },
  {
    path: R.PRODUCT_CATALOG,
    name: 'productCatalog',
    component: lanhu_2chanpinliebiao,
    meta: { seoId: 'productCatalog' }
  },
  {
    path: R.PRODUCT_MATRIX,
    name: 'productMatrix',
    component: lanhu_9chanpinjuzhen,
    meta: { seoId: 'productMatrix' }
  },
  {
    path: R.PRODUCT_CAPABILITY,
    name: 'productCapability',
    component: lanhu_wurenjijiejuefangan,
    meta: { seoId: 'productCapability' }
  },
  {
    path: R.PRODUCT_RF_DETECTION,
    name: 'productRfDetection',
    component: lanhu_3chanpinxiangqinga,
    meta: { seoId: 'productRf' }
  },
  {
    path: R.PRODUCT_COUNTER_B,
    name: 'productCounterB',
    component: lanhu_4chanpinxiangqingb,
    meta: { seoId: 'productCounterB' }
  },
  {
    path: R.PRODUCT_INTEGRATED,
    name: 'productIntegrated',
    component: lanhu_8chanpinxiangqinga,
    meta: { seoId: 'productIntegrated' }
  },
  {
    path: R.SOLUTION_INDUSTRY,
    name: 'solutionIndustry',
    component: lanhu_10hangyejiejuefangan,
    meta: { seoId: 'solutionIndustry' }
  },
  {
    path: R.SOLUTION_CUAS,
    name: 'solutionCuas',
    component: lanhu_10hangyejiejuefangan_1,
    meta: { seoId: 'solutionCuas' }
  },
  {
    path: R.SOLUTION_CUAS_ZH,
    name: 'solutionCuasZh',
    component: lanhu_jiejuefanganzhongwen,
    meta: { seoId: 'solutionCuasZh' }
  },
  {
    path: R.SOLUTION_CUAS_EN,
    name: 'solutionCuasEn',
    component: lanhu_jiejuefanganyingwen,
    meta: { seoId: 'solutionCuasEn' }
  },
  {
    path: R.SOLUTION_DRONE,
    name: 'solutionDrone',
    component: lanhu_wurenjijiejuefangan,
    meta: { seoId: 'solutionDrone' }
  },
  // Legacy URLs → 301-style client redirect to canonical paths
  ...Object.keys(LEGACY_PATH_MAP).map(oldPath => ({
    path: oldPath,
    redirect: to => legacyRedirect(to) || { path: R.HOME, query: to.query }
  })),
  {
    path: '/lanhu_5xinwenliebiao',
    redirect: to => ({ path: R.PROJECTS, query: to.query })
  },
  {
    path: '/lanhu_6xinwenxiangqing/:id?',
    redirect: to => ({ path: R.PROJECTS, query: to.query })
  },
  {
    path: '/lanhu_jiejuefanganliebiao',
    redirect: to => ({
      path: R.PRODUCTS,
      query: { ...to.query, cat: 'solution' }
    })
  },
  {
    path: '*',
    redirect: to => ({ path: R.HOME, query: to.query.lang ? { lang: to.query.lang } : { lang: 'en' } })
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' }
    }
    return { x: 0, y: 0 }
  }
})

/** Google 门户默认英文首页；明确 lang=zh 时保留中文 */
router.beforeEach((to, from, next) => {
  const isInitial = !from.matched || from.matched.length === 0
  if (isInitial && (to.path === R.HOME || to.path === '/')) {
    if (to.query.lang === 'zh') {
      next()
      return
    }
    if (to.query.lang !== 'en') {
      next({ path: R.HOME, query: { ...to.query, lang: 'en' }, hash: to.hash, replace: true })
      return
    }
  }
  next()
})

router.afterEach((to) => {
  applyRouteSeo(to)
})

export default router
